import { useScrollRestoration } from './useScrollRestoration';

const ScrollRestoration = () => {
	useScrollRestoration();
	return null;
};

export default ScrollRestoration;
